module.exports = __webpack_public_path__ + "img/Chainsaf(4).8d7cde32.jpg";